import { useState } from "react";
import { Check } from "../../components/Check/Check";
import { useAppDispatch, useAppSelector } from "../../state/store";
import { useNavigate } from "react-router";
import { SET_SETTINGS } from "../../state/reducers/settings";
import { Grid } from "@mui/material";
import { updateUser } from "../../state/actions/authentication";

interface SKSettingsProps {
  onGoBack: () => void;
}
export function SKSettings(props: SKSettingsProps) {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const settings = useAppSelector((state) => state.settings);
  const { user } = useAppSelector((state) => state.authentication);
  const material = useAppSelector((state) => state.material);
  const [editedSettings, setEditedSettings] = useState(settings);

  const saveButton = (
    <button
      className="clickable"
      onClick={() => {
        dispatch({ type: SET_SETTINGS, payload: editedSettings });
        if (user) {
          dispatch(
            updateUser({
              ...user,
              preferences: {
                ...user.preferences,
                settings: {
                  ...editedSettings,
                  // @ts-ignore
                  selectedChapters: undefined,
                  touchscreen: undefined,
                },
              },
            })
          );
        }
        props.onGoBack();
      }}
    >
      Save Settings
    </button>
  );
  return (
    <div className="main-box" style={{ marginTop: 10 }}>
      <h2>Scorekeeper Settings</h2>
      {saveButton}
      <br />
      <br />
      <Check
        checked={editedSettings.skAdvanced}
        onClick={(e) => {
          const newSettings = { ...editedSettings, skAdvanced: e };
          if (!e) newSettings.skResultColors = false;
          setEditedSettings(newSettings);
        }}
      >
        Advanced Mode
      </Check>
      <p style={{ fontSize: 12, marginTop: -2 }}>
        Will give you more options and stats, but will require slightly more
        data entry when keeping score.
      </p>
      {editedSettings.skAdvanced && (
        <>
          <Check
            checked={editedSettings.skResultColors}
            onClick={(e) =>
              setEditedSettings({ ...editedSettings, skResultColors: e })
            }
          >
            Colors on Pts/Err Results
          </Check>
          <br />
          <br />
        </>
      )}
      <Check
        checked={editedSettings.skIncludeOvertime}
        onClick={(value: boolean) =>
          setEditedSettings({ ...editedSettings, skIncludeOvertime: value })
        }
      >
        Include Overtime in Stats
      </Check>
      <p style={{ fontSize: 12, marginTop: -2 }}>
        You can change this in any Settings view, but this option will set the
        default.
      </p>

      {/* <Check
          checked={editedSettings.skDisableGraphs}
          onClick={(value: boolean) =>
            setEditedSettings({ ...editedSettings, skDisableGraphs: value })
          }
        >
          Disable Graphs
        </Check>
        <p style={{ fontSize: 12, marginTop: -2 }}>
          Gives simpler views instead of line graphs
        </p> */}
      <Check
        checked={editedSettings.skCompact}
        onClick={(e: boolean) =>
          setEditedSettings({ ...editedSettings, skCompact: e })
        }
      >
        Compact View
      </Check>
      <p style={{ fontSize: 12, marginTop: -2 }}>Good for Phones</p>
      <hr className="separator-line" />
      <h2>Books</h2>
      <p>
        Select which books you want to be included for verse selection. If you
        don't select any books, the current BQF year's books will be used.
      </p>
      <Grid container spacing={1}>
        {material.material.map((book, index) => (
          <Grid key={book.bookName}>
            <Check
              checked={editedSettings.selectedSKBooks[index]}
              style={{ width: 180 }}
              onClick={(value) => {
                const newBooks = [...editedSettings.selectedSKBooks];
                while (newBooks.length < index) {
                  newBooks.push(false);
                }
                newBooks[index] = value;
                setEditedSettings({
                  ...editedSettings,
                  selectedSKBooks: newBooks,
                });
              }}
            >
              {book.bookName}
            </Check>
          </Grid>
        ))}
      </Grid>
      <hr className="separator-line" />
      <button
        className="link"
        onClick={() => {
          dispatch({ type: SET_SETTINGS, payload: editedSettings });
          navigate("/sk/hotkeys");
          window.scrollTo(0, 0);
        }}
      >
        Edit Scorekeeper Hotkeys
      </button>
      <br />
      <br />
      {saveButton}
    </div>
  );
}
